import { render } from "./UnidadeLayout.vue?vue&type=template&id=34b4e676&scoped=true"
import script from "./UnidadeLayout.vue?vue&type=script&lang=js"
export * from "./UnidadeLayout.vue?vue&type=script&lang=js"

import "./UnidadeLayout.vue?vue&type=style&index=0&id=34b4e676&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b4e676"]])

export default __exports__